import {setLocale} from 'localization/i18n'
import {useEffect} from 'react'
import {useGetCurrentUserQuery, useGetUserQuery} from 'store/Store'

const useLanguage = () => {
    const {data: userToken} = useGetCurrentUserQuery()
    const {_id} = userToken || {}
    const {data: user} = useGetUserQuery(userToken?._id, {skip: !_id})

    useEffect(() => {
        if (user) {
            setLocale(user.language)
        }
    }, [user])
}

export default useLanguage
